/* eslint-disable */
// @generated by protobuf-ts 2.9.4 with parameter ts_nocheck,add_pb_suffix,keep_enum_prefix,eslint_disable
// @generated from protobuf file "web_services/candidate_experience/proto/config.proto" (package "applied.candidate_experience", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * Next ID: 2
 *
 * @generated from protobuf message applied.candidate_experience.Config
 */
export interface Config {
    /**
     * Deprecated: reskin is now always active. AppliedSans fonts and new logo are the default.
     *
     * @deprecated
     * @generated from protobuf field: bool is_applied_reskin_enabled = 1 [deprecated = true];
     */
    isAppliedReskinEnabled: boolean;
}
// @generated message type with reflection information, may provide speed optimized methods
class Config$Type extends MessageType<Config> {
    constructor() {
        super("applied.candidate_experience.Config", [
            { no: 1, name: "is_applied_reskin_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<Config>): Config {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isAppliedReskinEnabled = false;
        if (value !== undefined)
            reflectionMergePartial<Config>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Config): Config {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool is_applied_reskin_enabled = 1 [deprecated = true];*/ 1:
                    message.isAppliedReskinEnabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Config, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool is_applied_reskin_enabled = 1 [deprecated = true]; */
        if (message.isAppliedReskinEnabled !== false)
            writer.tag(1, WireType.Varint).bool(message.isAppliedReskinEnabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message applied.candidate_experience.Config
 */
export const Config = new Config$Type();
